// ////////////////////////////////////////////////////
// State  (ROOT)
// ////////////////////////////////////////////////////

/**
 * @returns {object}
 */
const getDefaultState = () => ({
  route: {},
  cognitoUserData: {},
  activeTeam: {},
  activeWorkspace: null,
  activeBrand: null,
  availableBrands: [],
  brandSelectionRequired: false,
  isNotFound: false,
  browzwearAPI: window.BwApi,
  isDarkMode: window.isDarkMode,
  seasons: []
})

export default getDefaultState
